import { Controller } from "@hotwired/stimulus"

// Intercepts Pay/Free button clicks in the public fees view (unauthenticated)
// and shows a login-required dialog instead of the normal subscription flow.
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this._intercept = this._intercept.bind(this)
    this.element.addEventListener("click", this._intercept, true)
  }

  disconnect() {
    this.element.removeEventListener("click", this._intercept, true)
  }

  _intercept(event) {
    const btn = event.target.closest("button[data-action]")
    if (!btn) return
    const action = btn.dataset.action || ""
    if (
      action.includes("subscription-options#toggle") ||
      action.includes("free-plan-alert#open")
    ) {
      event.stopPropagation()
      event.preventDefault()
      this.dialogTarget.showModal()
    }
  }

  closeDialog() {
    this.dialogTarget.close()
  }
}
